import { isUSDateTimeFormat } from '@kontentino/kontentino-utils/date';

type SharedBy = {
  name: string;
  email: string;
  accountUsername: string;
};

export const PublicUtils = {
  publicMock: {
    accountPlanType: 'trial',
    user: {
      id: 0,
      name: 'Guest',
      role: 'admin',
      avatar: null,
      userMeridianTime: !isUSDateTimeFormat(),
    } as const,
  },
  setSharedData: (user: SharedBy) => {
    PublicUtils.sharedBy = user;
  },
  getSharedData: () => PublicUtils.sharedBy,
  sharedBy: {
    name: '',
    email: '',
    accountUsername: '',
  } as SharedBy,
};

export default PublicUtils;
